import React, { useEffect } from 'react';

// helpers
import useFetch from 'hooks/useFetch';
import useQueryParam from 'hooks/useQueryParam';
import { useNavigate } from 'react-router-dom';
import { transactionsAPI } from 'api/accounting/transactionsAPI';

// components
import LoadingWrapper from 'components/WrapperComponents/LoadingWrapper';
import PageContentCard from 'modules/Layouts/MainLayout/PageRenderer/PageContentCard';
import InternalTransfer from '../../modules/Transfers/InternalTransfer';

const InternalTransferPage = () => {
  const navigate = useNavigate();
  const transactionIdFromQuery = useQueryParam({ param: 'transactionId' });
  const journalEntryIdFromQuery = useQueryParam({ param: 'journalEntryId' });

  const { response, loading, error } = useFetch(
    () =>
      journalEntryIdFromQuery || transactionIdFromQuery
        ? transactionsAPI.fetchInternalTransferPrefillData(
            journalEntryIdFromQuery,
            transactionIdFromQuery,
          )
        : null,
    [journalEntryIdFromQuery, transactionIdFromQuery],
  );

  useEffect(() => {
    if (journalEntryIdFromQuery || transactionIdFromQuery) {
      if (error || response) {
        navigate({ search: '' });
      }
    }
  }, [journalEntryIdFromQuery, transactionIdFromQuery, error, response]);

  return (
    <PageContentCard>
      <LoadingWrapper loading={loading}>
        <InternalTransfer prefillData={response} />
      </LoadingWrapper>
    </PageContentCard>
  );
};

export default InternalTransferPage;
